export default __webpack_public_path__ + "CircularCustCapNum-BoldItalic.c1a2ba2ef4dcdef8b3dcc74ad4b5057c.woff2";